<template>
     <ul class="crumbs mvt-breadcrumb" v-if="geo.statePath">
          <Schema v-if="!isBreadcrmbScriptHide" :text="breadCrumbSchema" />
          <li>
               <a :href="`${glb.appUrl}${isES ? 'es/' : ''}`">{{geo.homeText || molang('search.common.realEstate')}}</a>
          </li>
          <li v-if="forceSitemapPath">
               <a :href="`${glb.appUrl}sitemap/`">{{esPrefix}} United States</a>
          </li>
          <li v-if="geo.statePath">
               <a :href="glb.appUrl + getPath('statePath')">{{esPrefix}} {{geo.state}}{{breadCrumbSuffix}}</a>
          </li>
          <li v-if="geo.countyPath">
               <a :href="glb.appUrl + getPath('countyPath')">{{esPrefix}} {{geo.county}}{{breadCrumbSuffix}}</a>
          </li>
          <li v-if="geo.cityPath">
               <a :href="glb.appUrl + getPath('cityPath')">{{esPrefix}} {{geo.city}}{{breadCrumbSuffix}} {{contentVariant.isUnfilteredUnpaginatedCity ? molang('search.common.homesForSale') : ''}}</a>
          </li>
          <li v-if="geo.zipcodePath">
               <a :href="glb.appUrl + getPath('zipcodePath')">{{esPrefix}} {{geo.zipcode}}{{breadCrumbSuffix}}</a>
          </li>
          <li v-if="geo.neighborhoodPath && geo.neighborhood">
               <a :href="glb.appUrl + getPath('neighborhoodPath')">{{esPrefix}} {{geo.neighborhood}}{{breadCrumbSuffix}}</a>
          </li>
          <li v-if="geo.address">
               <span>{{geo.address}}{{breadCrumbSuffix}}</span>
          </li>
     </ul>
</template>
<script src="./mvt-breadcrumb.js"></script>

<style lang="scss">
@use "./mvt-breadcrumb.scss" as *;
</style>
